import { DefaultPageResponse } from '@/types'

export const getIndexTag = (
  isBrgAgent: boolean | undefined,
  page: string,
  handlerKey: string,
  defaultProperties?: DefaultPageResponse
): JSX.Element => {
  switch (page) {
    case 'Home':
      if (handlerKey === 'virgin') {
        return (
          <>
            <meta name="robots" content="index, follow" />
            <title>Virgin Australia Experiences and Activities - Earn and redeem Velocity Points</title>
            <meta
              name="description"
              content="Virgin Australia and Experience Oz partner to bring you a huge selection of over 4,000 experiences in Australia or New Zealand. Earn and redeem Velocity Points today."
            />
          </>
        )
      }
      if (isBrgAgent) {
        return (
          <>
            <title>Tours and Attractions Australia & New Zealand</title>
            <meta name="robots" content="index, follow" />
            <meta
              name="description"
              content="Over 4,000 things to do in Australia & New Zealand. Get the best value tours & attractions."
            />
          </>
        )
      }
    default:
      return isBrgAgent ? (
        <>
          <meta name="robots" content="index, follow" />
        </>
      ) : (
        <>
          <meta name="robots" content="noindex, nofollow" />
        </>
      )
  }
}
